import { useHistory } from "react-router-dom";
import { Chip, Grid, TextField, Typography } from "@material-ui/core";
import { Autocomplete } from "@mui/material";
import RegularButton from "components/CustomButtons/Button";
import { formatCustomDate } from "helpers/dateTools";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createGeneralInventory } from "redux/actions/inventories/inventoriesAction";
import CreateIcon from "@material-ui/icons/Create";
import { validateObject } from "helpers/validateObject";
import { inventoriesSearchInputs } from "redux/actions/inventories/inventoriesAction";
import { red } from "@material-ui/core/colors";
import { getEndowments } from "redux/actions/routesStatus/routesStatusAction";
import { getStorages } from "redux/actions/inventories/inventoriesAction";
import { getUnitsConfigs } from "redux/actions/unitsSection/unitsAction";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { getInventoryMobileEndowments } from "redux/actions/inventories/inventoriesAction";
const today = formatCustomDate(new Date(), "-");
export const AddInventoryForm = ({ onClose }) => {
  const dispatch = useDispatch();
  const hist = useHistory();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { units } = useSelector(({ unitsReducer }) => unitsReducer);
  const { stationsList, stations } = useSelector(({ companies }) => companies);
  const { station, inventories } = useSelector(
    ({ inventories }) => inventories
  );
  // const [station, setStation] = useState({});
  const [isError, setIsError] = useState(false);
  const [date, setDate] = useState(today);
  const handleChange = (e, v) => {
    const val = v ? v : null;
    dispatch(inventoriesSearchInputs("station", val));
  };

  const handleDate = ({ target }) => {
    setDate(target.value);
  };
  const handleNav = (id) => {
    hist.push(`/admin/inventario-detalles/${id}`);
  };

  const handleSubmit = () => {
    const openInventory = inventories.some((inv) => inv.status === "OPEN");
    if (openInventory) return setIsError(true);
    const currenDate = formatCustomDate(new Date(), "-");
    if (date > currenDate) {
      alert("La fecha no puede ser mayor a la actual");
      return;
    }
    dispatch(
      createGeneralInventory(
        {
          idStation: station.id,
          date: date,
        },
        stations,
        units,
        handleNav
      )
    );
    
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        minWidth: 400,
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "column",
        alignItems: "center",
        gap: 16,
        paddingTop: 16,
        // marginTop: 8
      }}
    >
      <TextField
        label="Fecha"
        variant="outlined"
        type="date"
        value={date}
        onChange={handleDate}
        inputProps={{
          max: today,
        }}
        fullWidth
      />
      <Autocomplete
        options={stationsList}
        value={station}
        getOptionLabel={(option) => (option.label ? option.label : option.name)}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              label={option?.name ? option.name : option.label}
              {...getTagProps({ index })}
              style={{
                borderRadius: 4,
              }}
            />
          ))
        }
        renderInput={(params) => (
          <TextField {...params} label="Plantas" variant="outlined" />
        )}
        // defaultValue={stations}
        fullWidth
        onChange={(e, v) => handleChange(e, v)}
        noOptionsText="No se encuentra la planta"
        // multiple
      />
      {isError && (
        <Typography
          variant="body1"
          style={{ color: red[500], textAlign: "center" }}
        >
          Ya existe un inventario abierto
        </Typography>
      )}

      {isLoadingComp?.loadingGeneralInventory ? (
        <LoadingComponent />
      ) : (
        <>
          <RegularButton color="info" fullWidth onClick={handleSubmit}>
            Crear Inventario
          </RegularButton>
          <RegularButton color="danger" fullWidth onClick={onClose}>
            Cancelar
          </RegularButton>
        </>
      )}
    </form>
  );
};
